/**
 * Primary domains that don't need warmup functionality
 * These are main business domains where warmup is typically not required
 * 
 * Note: Deactivated accounts (status === 'DEACTIVATED') should also be excluded
 * from warmup inactive counts as they're not actively being used.
 */
export const PRIMARY_DOMAINS = [
  'yotpo.com',
  'loopreturns.com',
  'cruva.com',
  'bayezon.ai',
  'gofishdigital.com',
  'storystream.it',
  'duel.tech'
] as const

/**
 * Check if an email belongs to a primary domain
 * @param email - The email address to check
 * @returns true if the email belongs to a primary domain
 */
export function isPrimaryDomain(email: string): boolean {
  if (!email) return false
  
  const domain = email.split('@')[1]?.toLowerCase()
  return domain ? PRIMARY_DOMAINS.includes(domain as any) : false
}

/**
 * Filter out primary domains from a list of mailboxes
 * @param mailboxes - Array of mailboxes to filter
 * @returns Filtered array excluding primary domains
 */
export function excludePrimaryDomains<T extends { email: string }>(mailboxes: T[]): T[] {
  return mailboxes.filter(mailbox => !isPrimaryDomain(mailbox.email))
}
